import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import {
  GenericComponentsModule,
  ResizeHandleModule,
} from '@helios/generic-components'
import { NgbNavModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap'
import {
  GridWrapperModule,
  TableLayoutModule,
} from '@northfork/ag-grid-angular'
import { DaterangeModule, NfFormsModule } from '@northfork/ng-basics'
import { ExternalFileManagerHeaderComponent } from './components/external-file-manager-header/external-file-manager-header.component'
import { NoExecutionsAvailableComponent } from './components/no-executions-available/no-executions-available.component'
import { NodesExplorerComponent } from './components/nodes-explorer/nodes-explorer.component'
import { PositionsGridComponent } from './components/positions-grid/positions-grid.component'
import { TransactionsGridComponent } from './components/transactions-grid/transactions-grid.component'
import { BulkActivateNewerExternalDataComponent } from './components/bulk-activate-newer-external-data/bulk-activate-newer-external-data.component'
import { ExternalFileManagerPanelComponent } from './external-file-manager-panel.component'
import { HttpNodeService } from './services/node/http-node.service'
import { NodeService } from './services/node/node.service'
import { HttpPositionsService } from './services/positions/http-positions.service'
import { PositionsService } from './services/positions/positions.service'
import { HttpTransactionService } from './services/transaction/http-transaction.service'
import { TransactionService } from './services/transaction/transaction.service'
import { HttpBulkActivateExternalDataService } from './services/bulkActivateNewerExternalData/http-bulkActivateExternalData.service'
import { BulkActivateExternalDataService } from './services/bulkActivateNewerExternalData/bulkActivateExternalData.service'

@NgModule({
  imports: [
    CommonModule,
    NfFormsModule,
    FormsModule,
    ReactiveFormsModule,
    GenericComponentsModule,
    GridWrapperModule,
    TableLayoutModule,
    NgbPopoverModule,
    NgbNavModule,
    ResizeHandleModule,
    DaterangeModule,
  ],
  declarations: [
    ExternalFileManagerPanelComponent,
    NodesExplorerComponent,
    PositionsGridComponent,
    TransactionsGridComponent,
    ExternalFileManagerHeaderComponent,
    NoExecutionsAvailableComponent,
    BulkActivateNewerExternalDataComponent,
  ],
  exports: [ExternalFileManagerPanelComponent],
  providers: [
    { useClass: HttpNodeService, provide: NodeService },
    { useClass: HttpPositionsService, provide: PositionsService },
    { useClass: HttpTransactionService, provide: TransactionService },
    {
      useClass: HttpBulkActivateExternalDataService,
      provide: BulkActivateExternalDataService,
    },
  ],
})
export class ExternalFileManagerModule {}

export { ExternalFileManagerPanelComponent }
